import type { ResolvedPageAnchor } from "resolvers/data/pageAnchorResolver";

const PageAnchor = (props: ResolvedPageAnchor) => {
    return <div id={props.id}></div>;
};

export default PageAnchor;
